import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { TicketsService, BulkLocationJob } from '../../../services/tickets.service';

/**
 * Tracks a background bulk-location-change job (see WeightItemController::changebulklocationAction,
 * which now enqueues instead of processing inline to avoid PHP-FPM/Apache/ALB request timeouts on
 * large batches) via its live Firebase RTDB doc, and emits once when it reaches a terminal state.
 */
@Component({
  selector: 'app-bulk-job-progress',
  templateUrl: './bulk-job-progress.component.html'
})
export class BulkJobProgressComponent implements OnChanges, OnDestroy {
  @Input() jobId: string | null = null;
  /** Firebase RTDB collection the job doc lives in — must match what the backend's FirebaseService wrote to. */
  @Input() jobCollection: string = 'weightItemBulkLocationJobs';
  @Output() done = new EventEmitter<BulkLocationJob>();

  job: BulkLocationJob | null = null;
  private sub: Subscription | null = null;
  private emitted = false;

  constructor(private ticketsService: TicketsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobId'] || changes['jobCollection']) {
      this.sub?.unsubscribe();
      this.job = null;
      this.emitted = false;

      if (this.jobId) {
        this.sub = this.ticketsService.watchBulkLocationJob(this.jobId, this.jobCollection).subscribe(job => {
          this.job = job;

          if (!this.emitted && job && (job.status === 'done' || job.status === 'error')) {
            this.emitted = true;
            this.done.emit(job);
          }
        });
      }
    }
  }

  get progressMode(): 'determinate' | 'indeterminate' {
    return this.job && this.job.totalItems > 0 ? 'determinate' : 'indeterminate';
  }

  get progressValue(): number {
    if (!this.job || !this.job.totalItems) {
      return 0;
    }
    return Math.round((this.job.processedItems / this.job.totalItems) * 100);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
